import { observer } from 'mobx-react-lite';
import * as React from 'react';

interface IProps {
    title?: string;
    includeSpendesk?: boolean;
}

export const Slide = observer<IProps>((props) => {
    return (
        <div className='slide'>
            <h2 className='slide-title'>
                {props.title}
            </h2>
            {props.children}
            <p style={{
                fontStyle: 'italic',
            }}>Source:
            {' '}<a href='https://www.visa.co.uk/support/consumer/travel-support/exchange-rate-calculator.html' target='blank'>Visa Europe</a> and
            {' '}<a href='https://www.mastercard.us/en-us/personal/get-support/convert-currency.html' target='blank'>Mastercard</a> live currency converters.
            {props.includeSpendesk ? (
                    <>
                        {' '}<a href='https://help.spendesk.com/hc/en-us/articles/115004740593-About-FX-fees' target='blank'>Spendesk</a> card fees.
                </>
                ) : null}
            </p>
        </div>
    );
});
